exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-page[data-v-6b8c5465]{width:100%;height:100%;padding:1rem;box-sizing:border-box}.admin-page h1[data-v-6b8c5465]{font-weight:400;font-size:1.4rem;padding:.2rem 0}.admin-page .tab-content[data-v-6b8c5465]{padding:.5rem 0;border-top:2px solid #ccc;margin-top:-1px}.admin-page .tabs[data-v-6b8c5465]{display:flex;width:100%}.admin-page .tabs .tab[data-v-6b8c5465]{padding:.4rem .5rem;cursor:pointer;font-size:1rem;margin-left:1rem;color:#555;border:1px solid #ccc;background-color:#e5e5e5;font-weight:400}.admin-page .tabs .tab.disabled[data-v-6b8c5465]{background-color:#949494;cursor:default}.admin-page .tabs .tab.active[data-v-6b8c5465]{border-bottom:0;background-color:#f1f1f1;color:#000;padding-bottom:calc(.4rem + 1px);margin-bottom:-1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b8c5465","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Admin.vue
// module id = 93
// module chunks = 0